<template>
  <div>
    <div class="newsInfo">基本信息</div>
    <el-form-item label="活动名称：" required>
      <el-input v-model="localConfig.activityName" :disabled="backgroundOpacity" maxlength="15" show-word-limit
        placeholder="请输入活动名称" style="width: 400px"></el-input>
    </el-form-item>
    <el-form-item label="活动时间：" required>
      <div class="my_select_time">
        <el-date-picker prefix-icon="no_icon" v-model="localConfig.activityStartTime" type="datetime" placeholder="开始日期"
          size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 185px; font-size: 12px" class="time1" @change="activityTimeChange"
          :picker-options="pickerOptionsValue" :default-time="this.$getDate(30)[0].substring(
            11,
            this.$getDate(30)[0].length
          )
            " :clearable="false" :disabled="isDisabled">
        </el-date-picker>
        <div class="time_to_text">至</div>
        <el-date-picker prefix-icon="no_icon" v-model="localConfig.activityEndTime" type="datetime" placeholder="结束日期"
          size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 200px; font-size: 12px" class="time2" @change="activityTimeChange" @focus="orderFocus"
          :picker-options="pickerOptionsValueEnd" :disabled="backgroundOpacity" :default-time="this.$getDate(30)[0].substring(
            11,
            this.$getDate(30)[0].length
          )
            " :clearable="false">
        </el-date-picker>
        <i class="el-icon-circle-close date_icon1" v-if="!activityData.isStart && !backgroundOpacity"
          @click="clearTime()"></i>
        <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
      </div>
      <span class="lastTime" style="color: #666">
        活动持续 <span style="color: #2768ff">{{ timeDay }}</span> 天
        <span style="color: #2768ff">{{ timeOut }}</span> 小时
        <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
          <el-button type="text" style="width: 35px">
            <i class="el-icon-question"></i>
          </el-button>
        </el-tooltip>
      </span>
      <div style="color: #ff0000;" v-if="isShowTip">
        *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
      </div>
    </el-form-item>

    <el-form-item label="活动对象：" prop="partner" required>
      <el-radio v-model="localConfig.actMember" label="1" :disabled="isDisabled">不限</el-radio>
      <el-radio v-model="localConfig.actMember" label="2" :disabled="isDisabled">指定身份</el-radio>
      <el-radio v-model="localConfig.actMember" label="3" :disabled="true">指定人群<el-button style="margin-left: 10px"
          v-if="localConfig.actMember == '3'" :disabled="isDisabled" @click="openCrowd">已选人群({{
            localConfig.peopleSelected.length
          }})</el-button></el-radio>

      <!-- 会员身份选择 -->
      <div v-if="localConfig.actMember == '2'" style="display: flex">
        <span>会员等级：</span>
        <el-checkbox-group v-model="localConfig.partner" @change="checkListchange" :disabled="isDisabled"
          v-if="localConfig.actMember == '2'">
          <el-checkbox label="-1" name="partner">全部</el-checkbox>
          <el-checkbox label="0" name="partner">非会员</el-checkbox>
          <el-checkbox v-for="(item, index) in localConfig.levelList" :key="index" :label="index + 1 + ''"
            name="partner">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div v-if="localConfig.actMember == '2'" style="display: flex">
        <span>入会时间：</span>
        <el-checkbox v-model="localConfig.isCheckOpenCardTime" :disabled="isDisabled">指定时间段</el-checkbox>
        <div class="my_select_time" style="margin-left: 8px">
          <el-date-picker prefix-icon="no_icon" v-model="localConfig.openCardStartTime" type="datetime"
            placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 185px; font-size: 12px" class="time1" :clearable="false" :default-time="'00:00:00'"
            :disabled="!localConfig.isCheckOpenCardTime || isDisabled">
          </el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker prefix-icon="no_icon" v-model="localConfig.openCardEndTime" type="datetime" placeholder="结束日期"
            size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 200px; font-size: 12px" class="time2" :picker-options="openCardEndTimeOptionsValue"
            :clearable="false" :default-time="'23:59:59'" :disabled="!localConfig.isCheckOpenCardTime || isDisabled">
          </el-date-picker>
          <i v-if="!activityData.isStart" class="el-icon-circle-close date_icon1" @click="clearNewTime"></i>
          <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
        </div>
      </div>
      <span v-if="localConfig.actMember == '2'" style="color: #f56c6c">注意：该条件对【非会员】身份不生效至少选择一个
      </span>
    </el-form-item>

    <!-- Plus会员限制 -->
    <el-form-item label="Plus会员身份：" required>
      <el-radio v-model="localConfig.plusObject" :label="0" :disabled="isDisabled">不限</el-radio>
      <el-radio v-model="localConfig.plusObject" :label="1" :disabled="isDisabled">Plus会员</el-radio>
      <el-radio v-model="localConfig.plusObject" :label="2" :disabled="isDisabled">非plus会员</el-radio>
      <div style="color:#F56C6C">注意：使用该判断需满足"与京东PLUS团队有合作关系的商家"及"京东PLUS团队准许调用本接口的商家"，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
      </div>
    </el-form-item>
    <el-form-item label="活动条件：">
      <el-checkbox label="关注店铺后方可参与活动" v-model="localConfig.condFollow" :disabled="isDisabled2"></el-checkbox>
    </el-form-item>

    <!-- 选择人群弹窗 -->
    <!-- <selectPeople v-if="selectPeopleShow" :dialogVisible="selectPeopleShow" :peopleList="peopleList"
      @confim="selectPeopleSure" @close="selectPeopleShow = false"></selectPeople> -->
  </div>
</template>

<script>
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
// import selectPeople from "@/components/select-people-yunqi.vue";

export default {
  name: 'BasicInfoForm',
  components: {
    // selectPeople,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    // 活动数据
    activityData: {
      type: Object,
      default: () => ({
        isStart: false
      })
    },
    backgroundOpacity: {
      type: Boolean,
      default: false
    },
    ids: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localConfig: this.value,
      timeDay: 0, // 活动持续天数
      timeOut: 0, // 活动持续小时数
      isShowTip: false, // 是否显示提示
      // 人群选择弹窗相关
      peopleList: [],
      selectPeopleShow: false,
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if (this.localConfig.activityStartTime) {
            return time.getTime() < new Date(this.localConfig.activityStartTime).getTime();
          }
        }
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          if (this.localConfig.openCardStartTime) {
            return time.getTime() < new Date(this.localConfig.openCardStartTime).getTime();
          }
        }
      }
    };
  },
  watch: {
    value: {
      handler(val) {
        this.localConfig = val;
      },
      deep: true
    },
    localConfig: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    }
  },
  computed: {
    isDisabled() { // 活动开始或查看状态后不可修改
      return this.activityData.isStart || this.backgroundOpacity;
    },
    isDisabled2() { // 查看状态不可修改
      return this.backgroundOpacity;
    }
  },
  created() {
    this.getLevel();
  },
  methods: {
    // 获取会员等级
    getLevel() {
      querymemberLevel().then((res) => {
        if (res.code == 1 || res.cdoe == 200) {
          if (res.data || res.data.length > 0) {
            res.data.forEach((item) => {
              this.localConfig.levelList.push({
                name: item.customerLevelName,
                value: String(item.customerLevel)
              });
            });
          }
        } else {
          this.$message.error(res.msg);
        }
      }).catch((res) => { });
    },
    // 计算活动持续时间
    calculateDuration() {
      if (this.localConfig.activityStartTime && this.localConfig.activityEndTime) {
        const startTime = new Date(this.localConfig.activityStartTime).getTime();
        const endTime = new Date(this.localConfig.activityEndTime).getTime();
        const diffTime = endTime - startTime;
        this.timeDay = Math.floor(diffTime / (24 * 60 * 60 * 1000));
        this.timeOut = Math.floor((diffTime % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
      } else {
        this.timeDay = 0; // 活动持续天数
        this.timeOut = 0; // 活动持续小时数
      }
    },
    activityTimeChange() {
      this.checkActivityTime([this.localConfig.activityStartTime, this.localConfig.activityEndTime]);
      this.$nextTick(() => {
        this.calculateDuration();// 计算活动持续时间
      });
    },
    // 活动时间变更
    checkActivityTime(timeData) {
      this.$nextTick(() => {
        if (timeData[0] && timeData[1]) {
          let nowTime = new Date().getTime();
          let start = new Date(timeData[0]).valueOf();
          let end = new Date(timeData[1]).valueOf();
          let invalidateDate = new Date(this.$store.getters.pointUserInfo.expiredIn).valueOf();
          let hdInvalidateDate = new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();
          console.log("--- this.$store.getters.pointUserInfo.expiredIn:---", this.$store.getters.pointUserInfo.expiredIn)
          console.log("--- this.$store.getters.loginUserInfo.expiredIn:---", this.$store.getters.loginUserInfo.expiredIn)

          // 查看不需要校验
          if (!this.backgroundOpacity) {
            if (start < nowTime) {
              if (this.ids) {
                this.disableTime = true;
              }
            }
            if (end < nowTime) {
              this.$message.warning("结束时间不能小于当前时间");
            }
            if (end < start) {
              this.$message.warning("结束时间不能小于开始时间");
              return;
            }
            if (end > invalidateDate) {
              this.$message.warning("活动时间不能超过软件有效期，请重新选择");
              this.localConfig.activityEndTime = null;
              return;
            }
            if (end > hdInvalidateDate) {
              this.$message.warning("活动时间不可超过互动数据授权有效期！");
              this.localConfig.activityEndTime = null;
              return;
            }
          }
        }
      });
    },
    // 清除时间
    clearTime() {
      this.localConfig.activityStartTime = null;
      this.localConfig.activityEndTime = null;
      this.timeDay = 0;
      this.timeOut = 0;
    },
    // 清除入会时间
    clearNewTime() {
      this.localConfig.openCardStartTime = '';
      this.localConfig.openCardEndTime = '';
    },
    // 订单焦点
    orderFocus() {
      if (this.activityData.isStart) {
        this.isShowTip = true
      }
    },
    // 复选框变更
    checkListchange(val) {
      // 重置选中状态
      this.levelIndex = 0
      // 当全部取消勾选时 勾选全部
      if (this.localConfig.partner.length == 0) {
        this.localConfig.partner = ["-1"];
        // 当勾选了别的选项却再次勾选全部时 勾选全部
      } else if (this.localConfig.partner.length > 1 && (this.localConfig.partner[this.localConfig.partner.length - 1] == -1)) {
        this.localConfig.partner = ["-1"];
        // 当勾选了除全部以外的所有选项时 勾选全部(这里面多了一个非会员所以要 +1)
      } else if (val.length == this.localConfig.levelList.length + 1) {
        this.localConfig.partner = ["-1"];
      } else {
        this.localConfig.partner = val.filter((item) => item != "-1");
      }
    },
    // 打开选择人群
    openCrowd() {
      this.peopleList = this.localConfig.peopleSelected.map((item) => {
        return { id: item };
      });
      this.selectPeopleShow = true;
      this.localConfig.actMember = "3";
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.localConfig.peopleSelected = val.map((item) => item.id);
      this.selectPeopleShow = false;
    }
  }
}

</script>